var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"littleModal",class:_vm.$style.modal,style:(_vm.cssProps),on:{"mousedown":_vm.handleMouseDown,"mouseup":_vm.handleMouseUp}},[_c('div',{class:_vm.$style.content,on:{"mousedown":_vm.contentMouseDown}},[_vm._t("content")],2),_c('div',{class:_vm.$style.btnGroup},[_vm._t("btn")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }